import { CheckboxSelector, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import React from 'react'
import useTranslation from '../../../i18n/useTranslation'
import FilterBadge from '../../../common/FilterBadge'

const TypesFilter = (props) => {
    const {typesFilters, setTypesFilters, types = [], useInner = false} = props
  const { translate } = useTranslation()
  const capitalize = (text) => {
    const result = text?.replace(/([A-Z])/g, " $1");
    return result?.charAt(0)?.toUpperCase() + result?.slice(1);
  }

  const typeOptions = types?.map((type) => ({
    name: capitalize(type),
    id: type
  }))

  const checkboxSelectorProps = {
    setDataFilters: setTypesFilters,
    direction: 'bottomCenter',
    dataFilters: typesFilters,
    typeFilter: 'statuses',
    data: typeOptions,
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }

  return (
    useInner ?
    <CheckboxSelectorInner style={{maxWidth: 'auto'}} {...checkboxSelectorProps}/> :
    <CheckboxSelector {...checkboxSelectorProps}>
      <FilterBadge
        title='Type'
        options={typeOptions}
        selectedIds={typesFilters}
        onClearFilters={() => setTypesFilters([])}
      />
    </CheckboxSelector>
  )
}
export default TypesFilter
